import { axiosPrivate } from "../../api/axios";
import handleError from "../../hooks/handleError";


// Save Bucket Transactions ("Save Changes")
const saveBucketTransactions = (buckets) => {

    let isMounted = true;
    const controller = new AbortController();

    const bucketTransToInsert = buckets.filter((row) => row.actions === "INSERT");
    const bucketTransToUpdate = buckets.filter((row) => row.actions === "UPDATE");
    const bucketTransToDelete = buckets.filter((row) => row.actions === "DELETE");


    const insertBucketTrans = async (bucketTransToInsert) => {
        try {
            await axiosPrivate.post("/bucket-transactions",
                bucketTransToInsert,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const updateBucketTrans = async (bucketTransToUpdate) => {
        try {
            await axiosPrivate.put("/bucket-transactions",
                bucketTransToUpdate,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const deleteBucketTrans = async (bucketTransToDelete) => {
        try {
            await axiosPrivate.post("/bucket-transactions/delete",
                bucketTransToDelete,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    if (bucketTransToDelete.length > 0) { deleteBucketTrans(bucketTransToDelete) };
    if (bucketTransToInsert.length > 0) { insertBucketTrans(bucketTransToInsert) };
    if (bucketTransToUpdate.length > 0) { updateBucketTrans(bucketTransToUpdate) };

};
export default saveBucketTransactions